import React from 'react';
import type { IconProps } from '../types';

export const EyeOff = React.memo<IconProps>(({
  size = 24,
  fillColor = '#1B1C1D',
  className,
  style,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill={fillColor} style={style} className={className} viewBox="0 0 24 24">
    <path fillRule="evenodd" d="M6.897 5.482C5.05 6.673 3.481 8.566 2.211 11.106a2 2 0 000 1.789C4.524 17.521 7.83 20.002 12 20.002c2.564 0 4.801-.937 6.681-2.735l-1.414-1.414c-1.517 1.432-3.273 2.149-5.268 2.149-3.333 0-6-2-8-6.001 1.208-2.417 2.66-4.103 4.355-5.06L6.897 5.482zm11.69 8.862c.503-.685.974-1.467 1.413-2.344-2-4-4.667-6-8-6-.549 0-1.081.054-1.594.163L8.788 4.545A9.437 9.437 0 0112 4c4.17 0 7.476 2.48 9.789 7.106a2 2 0 010 1.789 17.765 17.765 0 01-1.774 2.877l-1.427-1.427zm-8.619-5.79A3.998 3.998 0 008 12a4 4 0 004 4c1.467 0 2.75-.79 3.446-1.968L14.415 13h-.682a2 2 0 01-3.655-.447A1.965 1.965 0 0110 12a2 2 0 011-1.732v-.682L9.968 8.554z" />
    <path d="M2.81 4.222l1.414-1.414 16.971 16.971-1.414 1.414z" />
  </svg>
));
